import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  Billing,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.payment}billing/${COMMON_QUERY_PARAMS.BILLING_ID}`;

interface GetBillingQueryArgs {
  billingId: string;
}

const getBillingByIdQuery = async ({
  billingId,
}: GetBillingQueryArgs): Promise<
  BackResponse<Billing> | BackResponseFailure
> => {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.BILLING_ID, billingId);

    return await apiCall<BackResponse<Billing>>(url, {
      method: SUPPORTED_METHODS.GET,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default getBillingByIdQuery;
